import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 10000 },
    duration: { type: Number, default: 1200 }
  }

  connect() {
    this.element.style.transition = `opacity ${this.durationValue}ms ease`
    this.element.style.opacity = "1"

    this.fadeTimeout = window.setTimeout(() => {
      this.element.style.opacity = "0"

      this.removeTimeout = window.setTimeout(() => {
        this.element.remove()
      }, this.durationValue)
    }, this.delayValue)
  }

  disconnect() {
    if (this.fadeTimeout) window.clearTimeout(this.fadeTimeout)
    if (this.removeTimeout) window.clearTimeout(this.removeTimeout)
  }
}
